<template>
  <div>
    <a-modal
      v-model="visible"
      :width="1200"
      :title="$t('拣货单打印配置')"
      :confirmLoading="confirmLoading"
      :maskClosable="false"
      centered
      :okText="$t('保存')"
      @cancel="handleCancel"
      @ok="handleConfirm"
    >
      <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-row>
          <a-col :span="12" :offset="6">
            <a-form-item :label="$t('标题文字')">
              <a-input v-model="formItem.title" />
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item :label="$t('单据字段')" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-select v-model="formItem.headerFields" mode="multiple" style="width: 100%">
                <a-select-option value="delivery_order_number">{{ $t("出库单号") }}</a-select-option>
                <a-select-option value="warehouse">{{ $t("仓库") }}</a-select-option>
                <a-select-option value="client">{{ $t("货主") }}</a-select-option>
                <a-select-option value="order_type">{{ $t("订单类型") }}</a-select-option>
                <a-select-option value="counterparty">{{ $t("往来单位") }}</a-select-option>
                <a-select-option value="external_number">{{ $t("往来单位单号") }}</a-select-option>
                <a-select-option value="customer_contact">{{ $t("联系人") }}</a-select-option>
                <a-select-option value="contact_phone">{{ $t("联系人电话") }}</a-select-option>
                <a-select-option value="receiving_address">{{ $t("送货地址") }}</a-select-option>
                <a-select-option value="arrival_date">{{ $t("预计到货日") }}</a-select-option>
                <a-select-option value="delivery_method">{{ $t("发货方式") }}</a-select-option>
                <a-select-option value="payment_method">{{ $t("付款方式") }}</a-select-option>
                <a-select-option value="remark">{{ $t("备注") }}</a-select-option>
                <a-select-option value="creator">{{ $t("创建人") }}</a-select-option>
                <a-select-option value="create_time">{{ $t("创建时间") }}</a-select-option> 
              </a-select>
            </a-form-item>
          </a-col>
          <a-divider />

          <a-col :span="24">
            <a-form-item :label="$t('表头字段')" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-select v-model="formItem.tableFields" mode="multiple" style="width: 100%">
                <a-select-option value="material_number">{{ $t("货品编号") }}</a-select-option>
                <a-select-option value="material_name">{{ $t("货品名称") }}</a-select-option>
                <a-select-option value="material_barcode">{{ $t("货品条码") }}</a-select-option>
                <a-select-option value="total_quantity">{{ $t("数量") }}</a-select-option>
                <a-select-option value="length">{{ $t("长") }}</a-select-option>
                <a-select-option value="width">{{ $t("宽") }}</a-select-option>
                <a-select-option value="height">{{ $t("高") }}</a-select-option>
                <a-select-option value="volume">{{ $t("体积") }}</a-select-option>
                <a-select-option value="weight">{{ $t("重量") }}</a-select-option>
                <a-select-option value="total_volume">{{ $t("总体积") }}</a-select-option>
                <a-select-option value="total_weight">{{ $t("总重量") }}</a-select-option>
                <a-select-option value="spec">{{ $t("规格") }}</a-select-option>
                <a-select-option value="unit">{{ $t("单位") }}</a-select-option>
                <a-select-option value="batch_number">{{ $t("批次编号") }}</a-select-option>
                <a-select-option value="production_date">{{ $t("生产日期") }}</a-select-option>
                <a-select-option value="recommend_locations">{{ $t("推荐库位") }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('表格行数')" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-input-number v-model="formItem.tableRows" :min="1" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('表格排序')" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-space :size="16">
                <div>
                  <a-radio-group v-model="formItem.tableSortType" button-style="solid">
                    <a-radio-button value="positive">{{ $t("正序") }}</a-radio-button>
                    <a-radio-button value="reverse">{{ $t("倒序") }}</a-radio-button>
                  </a-radio-group>
                </div>
                <div>
                  <a-select v-model="formItem.tableSortField" allowClear style="width: 256px">
                    <a-select-option value="total_quantity">{{ $t("数量") }}</a-select-option>
                  </a-select>
                </div>
              </a-space>
            </a-form-item>
          </a-col>

          <a-divider />

          <a-col :span="24">
            <a-form-item :label="$t('与表格间距')" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-input-number v-model="formItem.tableMarginBottom" :min="1" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('左部文字')">
              <a-input v-model="formItem.leftTextContent" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('右部文字')">
              <a-input v-model="formItem.rightTextContent" />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('左部文字属性')">
              <a-space :size="16">
                <div>字号: <a-input-number v-model="formItem.leftTextFontSize" :min="12" /></div>
                <div>
                  <a-radio-group v-model="formItem.leftTextAlign" button-style="solid" style="text-align: center">
                    <a-radio-button value="left"><a-icon type="pic-left" /></a-radio-button>
                    <a-radio-button value="center"><a-icon type="pic-center" /></a-radio-button>
                    <a-radio-button value="right"><a-icon type="pic-right" /></a-radio-button>
                  </a-radio-group>
                </div>
                <div>
                  <a-checkbox v-model="formItem.leftTextFontWeight">{{ $t("粗体") }}</a-checkbox>
                  <a-checkbox v-model="formItem.leftTextFontItalic">{{ $t("斜体") }}</a-checkbox>
                </div>
              </a-space>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('右部文字属性')">
              <a-space :size="16">
                <div>{{ $t("字号") }}: <a-input-number v-model="formItem.rightTextFontSize" :min="12" /></div>
                <div>
                  <a-radio-group v-model="formItem.rightTextAlign" button-style="solid" style="text-align: center">
                    <a-radio-button value="left"><a-icon type="pic-left" /></a-radio-button>
                    <a-radio-button value="center"><a-icon type="pic-center" /></a-radio-button>
                    <a-radio-button value="right"><a-icon type="pic-right" /></a-radio-button>
                  </a-radio-group>
                </div>
                <div>
                  <a-checkbox v-model="formItem.rightTextFontWeight">{{ $t("粗体") }}</a-checkbox>
                  <a-checkbox v-model="formItem.rightTextFontItalic">{{ $t("斜体") }}</a-checkbox>
                </div>
              </a-space>
            </a-form-item>
          </a-col>
          <a-divider />

          <a-col :span="24">
            <a-form-item :label="$t('底部文字')" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-input v-model="formItem.bottomTextContent" />
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item :label="$t('底部文字属性')" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-space :size="16">
                <div>{{ $t("字号") }}: <a-input-number v-model="formItem.bottomTextFontSize" :min="12" /></div>
                <div>
                  <a-radio-group v-model="formItem.bottomTextAlign" button-style="solid" style="text-align: center">
                    <a-radio-button value="left"><a-icon type="pic-left" /></a-radio-button>
                    <a-radio-button value="center"><a-icon type="pic-center" /></a-radio-button>
                    <a-radio-button value="right"><a-icon type="pic-right" /></a-radio-button>
                  </a-radio-group>
                </div>
                <div>
                  <a-checkbox v-model="formItem.bottomTextFontWeight">{{ $t("粗体") }}</a-checkbox>
                  <a-checkbox v-model="formItem.bottomTextFontItalic">{{ $t("斜体") }}</a-checkbox>
                </div>
              </a-space>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('与底边间距')" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-input-number v-model="formItem.bottomTextBottom" :min="1" style="width: 100%" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { printConfigsSave } from "@/api/system";

export default {
  props: ["visible"],
  model: { prop: "visible", event: "cancel" },
  computed: {
    configItem() {
      return this.$store.state.user.pickingOrderPrintConfig;
    },
  },
  data() {
    return {
      confirmLoading: false,
      formItem: {},
    };
  },
  methods: {
    handleConfirm() {
      this.confirmLoading = true;
      printConfigsSave({ picking_order_print_config: this.formItem })
        .then(() => {
          this.handleCancel();
          this.$router.go(0);
        })
        .finally(() => (this.confirmLoading = false));
    },
    handleCancel() {
      this.$emit("cancel", false);
    },
  },
  watch: {
    visible(status) {
      if (status) {
        this.formItem = { ...this.configItem };
      }
    },
  },
};
</script>

<style scoped></style>
